// test2857
(2857 && 0);
